import React from 'react';
import { Skeleton, Container, Grid } from '@mui/material';

const GeoWidgetSectionSkeleton = () => (
  <Container maxWidth="xl">
    <Grid container spacing={1} pb={2} pt={1}>
      <Grid item lg={3} md={6} xs={12} >
        <Skeleton variant="rectangular" width="320px" height={30} />
      </Grid>
        <Grid item lg={3} md={6} xs={12} className="showDESKTOP" >
        <Skeleton variant="rectangular" width="320px" height={30} />
      </Grid>
      <Grid item lg={2} md={6} xs={12} className="showDESKTOP">
        <Skeleton variant="rectangular" width="150px" height={30} />
      </Grid>
      <Grid item lg={2} md={6} xs={12} className="showDESKTOP">
        <Skeleton variant="rectangular" width="150px" height={30} />
      </Grid>
      <Grid item lg={2} md={6} xs={12} className="showDESKTOP">
        <Skeleton variant="rectangular" width="150px" height={30} />
      </Grid>
    </Grid>
  </Container>
);
export { GeoWidgetSectionSkeleton };
